import React from 'react';
import {useIntl} from 'react-intl';
import {Pill} from '@forecast-it/design-system';
import {SaveState} from '../shared/saveState';
import {NovaStudioVariant, TASK_AGENT_VARIANT} from './novaStudioVariant';

export function SaveStatePill({
	saveState,
	variant = TASK_AGENT_VARIANT,
}: {
	saveState: SaveState;
	variant?: NovaStudioVariant;
}): JSX.Element {
	const {formatMessage} = useIntl();
	return (
		<span data-cy="nova-save-state">
			<Pill outlined outlinedVariant={variant.saveStateVariants[saveState]}>
				{formatMessage({id: variant.saveStateLabelIds[saveState]})}
			</Pill>
		</span>
	);
}
